import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const agentsCatalogPlugin = createPlugin({
  id: 'agents-catalog',
  routes: {
    root: rootRouteRef,
  },
});

export const AgentsCatalogPage = agentsCatalogPlugin.provide(
  createRoutableExtension({
    name: 'AgentsCatalogPage',
    component: () =>
      import('./components/AgentsCatalogPage').then(m => m.AgentsCatalogPage),
    mountPoint: rootRouteRef,
  }),
);
